export default "__VITE_ASSET__xkpk6EtB__"